import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  login as apiLogin,
  register as apiRegister,
  fetchMe,
  setCustomerToken,
  clearCustomerToken,
  getCustomerToken,
  exchangeGoogleSession,
} from "../lib/customerApi";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  // null = checking, false = guest, user object = authed
  const [user, setUser] = useState(null);

  useEffect(() => {
    const t = getCustomerToken();
    if (!t) {
      setUser(false);
      return;
    }
    fetchMe()
      .then(setUser)
      .catch(() => {
        clearCustomerToken();
        setUser(false);
      });
  }, []);

  const login = useCallback(async (email, password) => {
    const { access_token, user } = await apiLogin(email, password);
    setCustomerToken(access_token);
    setUser(user);
    return user;
  }, []);

  const register = useCallback(async (payload) => {
    const { access_token, user } = await apiRegister(payload);
    setCustomerToken(access_token);
    setUser(user);
    return user;
  }, []);

  const googleSession = useCallback(async (sessionId) => {
    const { access_token, user } = await exchangeGoogleSession(sessionId);
    setCustomerToken(access_token);
    setUser(user);
    return user;
  }, []);

  const signOut = useCallback(() => {
    clearCustomerToken();
    setUser(false);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const fresh = await fetchMe();
      setUser(fresh);
    } catch {
      // ignore
    }
  }, []);

  return (
    <CustomerAuthContext.Provider value={{ user, login, register, googleSession, signOut, refresh }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error("useCustomerAuth must be used within CustomerAuthProvider");
  return ctx;
};
